import React from 'react';
import truncate from 'truncate-markup-string';
import c from 'classnames';

import { CARD_SUBTITLE_MAX_LENGTH } from '../../../config/constants';
import { BaseCardProps } from '../types';
import WysiwygField from '../../WysiwygField';

interface CardSubtitleProps extends Pick<BaseCardProps, 'subtitle'> {
  isTruncated?: boolean;
  className?: string;
}

const CardSubtitle: React.FC<CardSubtitleProps> = (props) => {
  const { subtitle, isTruncated = true, className } = props;
  const classNames = c('Card__subtitle', className);

  if (!subtitle) {
    return null;
  }

  return (
    <WysiwygField
      className={classNames}
      property="schema:text"
      html={isTruncated ? truncate(subtitle, CARD_SUBTITLE_MAX_LENGTH, '<span>', '</span>', true) : subtitle}
    />
  );
};

export default CardSubtitle;
